///<reference path="../../../typings/api.d.ts" />

import { HttpVerb } from "../../constants";
import { NonServiceInstance } from "api";

const search = async ({
  searchTerm,
  country,
  lang,
  brand,
  useclientprodapis,
  cancelToken,
  searchUrl
}) => {
  console.log(`Search api called with param ${searchTerm}`);
  if (!searchUrl) return null;

  const queryParams = {
    country,
    lang,
    brand,
    term: searchTerm,
    useProdApis: useclientprodapis === "true" ? useclientprodapis : undefined
  };

  const url = new URL(searchUrl);
  Object.keys(queryParams).map(key =>
    url.searchParams.set(key, queryParams[key])
  );

  return await NonServiceInstance?.request({
    method: HttpVerb.GET,
    url: url.toString(),
    cancelToken
  });
};

export default {
  search
};
